export class Banco{
    numero:string
    nome:string
}